import React from "react";

const OverlayOnly = ({ team_logo, config }) => (
  <div className="Headshot" style={config.headShotStyle}>
    <img className="Team" style={config.teamLogoStyle} src={team_logo} alt="Team Logo" />
    <div className="Bg" style={config.bgStyle}></div>
    <div className="Fg" style={config.fgStyle}>
      <div className="Rectangle1" style={config.rectangle1Style}></div>
      <div className="Rectangle3" style={config.rectangle3Style}></div>
    </div>
  </div>
);

const OverlayWithPlayer = ({ team_logo, headshot, config }) => (
  <div className="Headshot" style={config.headShotStyle}>
    <img className="Team" style={config.teamLogoStyle} src={team_logo} alt="Team Logo" />
    <div className="Bg" style={config.bgStyle}></div>
    <img className="Athlete" style={config.athleteStyle} src={headshot} alt="Player" />
    <div className="Fg" style={config.fgStyle}>
      <div className="Rectangle1" style={config.rectangle1Style}></div>
      <div className="Rectangle3" style={config.rectangle3Style}></div>
    </div>
  </div>
);

const PlayerOnly = ({ headshot }) => (
  <img src={headshot} alt="Player" style={{ height: "100%", objectFit: "cover" }} />
);

const CompactHeadshot = ({ headshot, team_logo, useOverlay, config }) => {
  return (
    <div style={{ maxHeight: '80px', height: "78px", width: "100%", position: "relative" }}>
      {!headshot ? (
        <OverlayOnly team_logo={team_logo} config={config} />
      ) : useOverlay ? (
        <OverlayWithPlayer team_logo={team_logo} headshot={headshot} config={config} />
      ) : (
        <PlayerOnly headshot={headshot} />
      )}
    </div>
  )
}

const HeadShot = ({ headshot, team_logo, useOverlay, compact=false }) => {

  const config = {
    headShotStyle,
    teamLogoStyle,
    bgStyle,
    athleteStyle,
    fgStyle,
    rectangle1Style,
    rectangle3Style
  }

  if (compact) {

    const compactConfig = {
      headShotStyle,
      teamLogoStyle,
      bgStyle,
      athleteStyle: athleteStyleCompact,
      fgStyle,
      rectangle1Style,
      rectangle3Style
    }
    return <CompactHeadshot headshot={headshot} team_logo={team_logo} useOverlay={useOverlay} config={compactConfig} />

  }
  return (
    <div style={{ height: "250px", width: "100%", position: "relative" }}>
      {!headshot ? (
        <OverlayOnly team_logo={team_logo} config={config} />
      ) : useOverlay ? (
        <OverlayWithPlayer team_logo={team_logo} headshot={headshot} config={config} />
      ) : (
        <PlayerOnly headshot={headshot}  />
      )}
    </div>
  );
};

export default HeadShot;

const headShotStyle = {
  overflow: "hidden",
  width: "100%",
  height: "100%",
  position: "absolute",
  background: "linear-gradient(0deg, white 0%, white 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%)",
};

const teamLogoStyle = {
  height: "88%",
  left: "8.6%",
  top: "8%",
  opacity: 0.4,
  position: "absolute"
};

const bgStyle = {
  width: "100%",
  height: "56.25%",
  left: "18.9%",
  top: "124.44%",
  position: "absolute",
  transform: "rotate(-72deg)",
  transformOrigin: "0 0",
  background: "rgba(255, 255, 255, 0.40)",
  boxShadow: "-6px 4px 12px rgba(0, 0, 0, 0.10)",
  border: "1px rgba(255, 255, 255, 0.10) solid",
};

const athleteStyleCompact = {
  height: "100%",
  left: "20%",
  bottom: 0,
  position: "absolute",
  objectFit: "cover",
};

const athleteStyle = {
  height: "95.63%",
  left: "35%",
  top: "4.38%",
  position: "absolute",
  objectFit: "cover",
};

const fgStyle = {
  width: "171.68%",
  height: "178.07%",
  left: "-36.51%",
  top: "-38.44%",
  position: "absolute",
};

const rectangle1Style = {
  width: "52.73%",
  height: "31.59%",
  left: "65.41%",
  top: "90.24%",
  position: "absolute",
  transform: "rotate(-72deg)",
  transformOrigin: "0 0",
  background: "rgba(255, 255, 255, 0.80)",
  boxShadow: "-6px 4px 12px rgba(0, 0, 0, 0.25)",
  border: "1px rgba(255, 255, 255, 0.20) solid",
};

const rectangle3Style = {

};